import { CollapsibleContainer, DateInput, SolidCircleCheckIcon, TextInput } from 'slab'

import { useOnboarding } from '../OnboardingContext'

export function SelfParticipantCard () {
  const { onboardingData } = useOnboarding()

  return (
    <CollapsibleContainer
      defaultOpen={false}
      heading='You'
      headingIconContent={
        <div className='text-green-400'>
          <SolidCircleCheckIcon aria-label='(complete)' size={16} />
        </div>
      }
    >
      <div className='p-4 space-y-4'>
        <div className='flex flex-col xs:flex-row gap-4'>
          <div className='flex-1'>
            <TextInput
              label='First name'
              value={onboardingData?.member?.given_name || ''}
              disabled
            />
          </div>
          <div className='flex-1'>
            <TextInput
              label='Last name'
              value={onboardingData?.member?.family_name || ''}
              disabled
            />
          </div>
          <div className='flex-1'>
            <DateInput
              label='Date of birth'
              value={onboardingData?.member?.date_of_birth || ''}
              disabled
            />
          </div>
        </div>
      </div>
    </CollapsibleContainer>
  )
}
